import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

export const DEFAULTS = {
  company: {
    name: "TERMONLINE",
    legal_name: "[Ragione sociale]",
    vat: "[Partita IVA]",
    address: "[Indirizzo sede legale]",
    email: "termomodeonline@gmail.com",
    phone: "+39 366 205 5798",
    whatsapp: "393662055798",
    whatsapp_message: "Ciao TERMONLINE, vorrei informazioni sul programma di acquisizione clienti.",
  },
  notifications: { email: "termomodeonline@gmail.com" },
  seo: {
    title: "TERMONLINE · Programma di acquisizione clienti per installatori di impianti",
    description: "Il programma di acquisizione clienti dedicato alle aziende di pompe di calore, climatizzazione e fotovoltaico. Profiliamo i clienti e fissiamo i sopralluoghi nel tuo calendario: tu vai all'appuntamento e realizzi l'impianto.",
    og_image: "",
  },
  tracking: {
    ga4_id: "",
    gtm_id: "",
    meta_pixel_id: "",
    conversion_event: "generate_lead",
    events: [
      { enabled: true, meta_event: "Lead", custom_name: "", trigger: "invio_modulo", url: "", match: "contiene", target: "", value: "", currency: "EUR", platforms: "tutte" },
      { enabled: true, meta_event: "Contact", custom_name: "", trigger: "click", url: "", match: "contiene", target: "https://wa.me", value: "", currency: "EUR", platforms: "tutte" },
      { enabled: true, meta_event: "Custom", custom_name: "ClickConsulenza", trigger: "click", url: "", match: "contiene", target: "Richiedi una consulenza", value: "", currency: "EUR", platforms: "tutte" },
      { enabled: true, meta_event: "ViewContent", custom_name: "", trigger: "pagina", url: "/programma", match: "contiene", target: "", value: "", currency: "EUR", platforms: "meta" },
    ],
  },
  home: {
    hero_eyebrow: "Programma di acquisizione clienti · Settore impianti",
    hero_title: "Più contatti qualificati.\nPiù sopralluoghi.\nPiù installazioni.",
    hero_subtitle: "Il programma di acquisizione clienti dedicato alle aziende di pompe di calore, climatizzazione e fotovoltaico.",
    hero_cta_primary: "Scopri il programma",
    hero_cta_secondary: "Richiedi una consulenza",
    hero_claim: "Noi troviamo i clienti e fissiamo il sopralluogo nel tuo calendario. Tu vai all'appuntamento e realizzi l'impianto.",
    marquee: ["Pompe di calore", "Climatizzazione", "Fotovoltaico", "Termoidraulica", "Richieste qualificate", "Sopralluoghi", "Preventivi"],
    manifesto_label: "Non siamo la solita agenzia",
    manifesto_title: "Non vendiamo pubblicità. Abbiamo costruito un sistema per acquisire clienti.",
    manifesto_text: "Niente servizi a pezzi. Un programma completo e già definito, pensato solo per le imprese degli impianti.",
    manifesto_not: ["Pacchetti social", "Campagne da gestire", "Servizi venduti a pezzi"],
    manifesto_yes: ["Un unico programma", "Clienti già profilati", "Sopralluoghi già in agenda"],
    process_label: "Come funziona",
    process_title: "Dal primo interesse al sopralluogo. Un processo strutturato.",
    process_steps: [
      { title: "Troviamo clienti interessati", text: "Persone che stanno valutando un nuovo impianto nella tua zona." },
      { title: "Profiliamo le richieste", text: "Verifichiamo impianto, immobile, zona e tempi. Chi non è in target viene scartato." },
      { title: "Fissiamo noi il sopralluogo", text: "Contattiamo il cliente e inseriamo l'appuntamento nel tuo calendario." },
      { title: "Tu vai all'appuntamento", text: "Incontri il cliente, fai il sopralluogo, il preventivo e installi." },
    ],
    leads_label: "Contatti caldi e profilati",
    leads_title: "Non tutti i contatti sono potenziali clienti. I nostri vengono qualificati.",
    leads_text: "Non ricevi solo un nome e un numero. Sai già cosa vuole installare il cliente e dove, e trovi il sopralluogo già nel tuo calendario.",
    sectors_label: "Un programma, tre settori",
    sectors_title: "Specializzati solo nel tuo settore.",
    sectors_note: "Lavoriamo anche con imprese termoidrauliche.",
    sectors: [
      { name: "Pompe di calore", kicker: "Riscaldamento", text: "Chi vuole sostituire la caldaia o installare una pompa di calore.", points: ["Nuovi impianti", "Sostituzione caldaia"], image: "/img/pompe.jpg" },
      { name: "Climatizzazione", kicker: "Raffrescamento", text: "Chi cerca un installatore per nuovi climatizzatori o sostituzioni.", points: ["Mono e multi-split", "Casa e ufficio"], image: "/img/clima.jpg" },
      { name: "Fotovoltaico", kicker: "Energia", text: "Chi vuole produrre energia in casa o in azienda, anche con accumulo.", points: ["Residenziale", "Accumulo"], image: "/img/fv.jpg" },
    ],
    cases_label: "Casi studio",
    cases_title: "Il valore di un metodo si misura nei risultati.",
    cases_text: "Solo risultati reali e documentati.",
    cta_label: "Richiesta consulenza",
    cta_title: "Tu installi impianti. Noi alimentiamo le tue opportunità commerciali.",
    cta_subtitle: "Scopri come il programma TERMONLINE può portare nuove richieste qualificate alla tua azienda.",
    cta_button: "Richiedi una consulenza",
    form_success: "Grazie! Ti ricontatteremo a breve.",
  },
  program: {
    hero_label: "Il programma TERMONLINE",
    hero_title: "Un sistema completo per portare nuove richieste alla tua azienda.",
    hero_text: "Troviamo persone interessate, le profiliamo e fissiamo il sopralluogo nel tuo calendario. Tu vai solo all'appuntamento.",
    image: "/img/programma.jpg",
    phases_title: "Cinque fasi, ruoli chiari.",
    phases: [
      { title: "Acquisizione", owner: "TERMONLINE", text: "Troviamo chi vuole un nuovo impianto." },
      { title: "Profilazione", owner: "TERMONLINE", text: "Filtriamo le richieste non in target." },
      { title: "Appuntamento", owner: "TERMONLINE", text: "Fissiamo il sopralluogo nel tuo calendario." },
      { title: "Sopralluogo", owner: "La tua azienda", text: "Vai direttamente dal cliente." },
      { title: "Preventivo", owner: "La tua azienda", text: "Fai l'offerta e installi." },
    ],
    us_title: "Cosa fa TERMONLINE",
    us_points: ["Trova clienti interessati", "Profila ogni richiesta", "Fissa il sopralluogo in agenda"],
    you_title: "Cosa fa la tua azienda",
    you_points: ["Va all'appuntamento", "Fa il preventivo", "Vende e installa"],
    faq_title: "Domande frequenti",
    faq: [
      { q: "Vendete pubblicità o pacchetti social?", a: "No. Offriamo un unico programma per acquisire clienti nel settore impianti." },
      { q: "Chi fissa l'appuntamento?", a: "Noi. Dopo la profilazione contattiamo il cliente e inseriamo il sopralluogo nel tuo calendario. Tu vai direttamente all'appuntamento." },
      { q: "Che informazioni ricevo?", a: "Tipo di impianto, immobile, zona e tempi indicati dal cliente." },
      { q: "Con quali settori lavorate?", a: "Pompe di calore, climatizzazione, fotovoltaico e termoidraulica." },
    ],
  },
};

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

export function deepMerge(base, over) {
  if (!isObj(over)) return base;
  const out = { ...base };
  Object.keys(over).forEach((k) => {
    const v = over[k];
    if (v === undefined || v === null) return;
    out[k] = isObj(base?.[k]) && isObj(v) ? deepMerge(base[k], v) : v;
  });
  return out;
}

const ContentCtx = createContext({ content: DEFAULTS, loaded: false });

export function ContentProvider({ children }) {
  const [state, setState] = useState({ content: DEFAULTS, loaded: false });
  useEffect(() => {
    let alive = true;
    api.get("/content")
      .then((r) => { if (alive) setState({ content: deepMerge(DEFAULTS, r?.data), loaded: true }); })
      .catch(() => { if (alive) setState({ content: DEFAULTS, loaded: true }); });
    return () => { alive = false; };
  }, []);
  return <ContentCtx.Provider value={state}>{children}</ContentCtx.Provider>;
}

export const useContent = () => useContext(ContentCtx).content;
